
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("eBpal", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.c2707ff4.js.map
